import React from "react";
import "./index.css";

import facebookIcon from '../../assests/footer_facebook.png';
import instagramIcon from '../../assests/footer_instagram.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-left">
        <p>
          Copyright @ 2025. STUDIO KARA All Rights Reserved. | Concept & Design by{" "}
          <span className="designer-name">eparivartan</span>
        </p>
      </div>
      <div className="footer-right">
        <img src={facebookIcon} alt="Facebook" className="social-icon" />
        <img src={instagramIcon} alt="Instagram" className="social-icon" />
      </div>
    </footer>
  );
};

export default Footer;
